import React from "react";
import { Check } from "lucide-react";

interface CanvasCommentPinProps {
  x: number;
  y: number;
  scale: number;
  index: number;
  isResolved: boolean;
  repliesCount: number;
  isActive: boolean;
  onClick: () => void;
}

export const CanvasCommentPin: React.FC<CanvasCommentPinProps> = ({
  x,
  y,
  scale,
  index,
  isResolved,
  repliesCount,
  isActive,
  onClick,
}) => {
  const scaledX = x * scale;
  const scaledY = y * scale;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      style={{
        position: "absolute",
        left: scaledX,
        top: scaledY,
        transform: "translate(-50%, -50%)",
        zIndex: 49,
        cursor: "pointer",
      }}
    >
      {/* Pin bubble */}
      <div
        style={{
          backgroundColor: isResolved
            ? "#10b981"
            : isActive
              ? "#EA33C0"
              : "#1a1a2e",
          color: "white",
          borderRadius: isActive ? "20px" : "50% 50% 50% 0%",
          width: isActive ? "auto" : 26,
          height: 26,
          minWidth: 26,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 11,
          fontWeight: 700,
          boxShadow: isActive
            ? "0 4px 16px rgba(234,51,192,0.5)"
            : "0 2px 8px rgba(0,0,0,0.3)",
          border: isActive ? "2.5px solid white" : "2px solid white",
          padding: isActive ? "0 8px" : undefined,
          transform: "rotate(0deg)",
          transition: "all 0.15s ease",
          gap: 4,
          whiteSpace: "nowrap",
        }}
      >
        {isResolved ? (
          <Check size={12} strokeWidth={3} />
        ) : (
          <>
            <span>{index}</span>
            {repliesCount > 0 && (
              <span style={{ fontSize: 9, opacity: 0.8 }}>+{repliesCount}</span>
            )}
          </>
        )}
      </div>

      {/* Active ring pulse */}
      {isActive && (
        <div
          style={{
            position: "absolute",
            inset: -6,
            borderRadius: "50%",
            border: "2px solid rgba(234,51,192,0.4)",
            animation: "ping 1s cubic-bezier(0,0,0.2,1) infinite",
            pointerEvents: "none",
          }}
        />
      )}
    </div>
  );
};
